<template>
  <div>
    <div class="background"></div>
    <Header></Header>
    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
              <div class="news-main">
                <div class="listArea">
                  <ul class="list" v-for="(e,index) in dynamicList" :key="index">
                    <li class="title">
                      <router-link :to="{path:'/dynamicdetail',query:{id:e.id}}">
                        {{e.title}}
                      </router-link>
                    </li>
                    <li class="intr">{{e.intr}}</li>
                    <li class="author">
                      <div class="publishing">发布单位：<div style="display: inline-block;">{{e.editor}}</div>
                      </div>
                      <div class="pubtime">发布时间：<div style="display: inline-block;">{{e.time}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :page-size="10"
                  :current-page="1" @current-change="handleCurrentChange">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dynamicList: [],
        newslist: '',
        total: 0,
        page: 1
      };
    },

    components: {},

    mounted() {
      this.getDynamicList()
      // this.getNewsList();
    },

    methods: {
      // /www.csaln.cn/api/dynamic/dynamiclist
      getDynamicList() {
        this.instance.get('/api/dynamic/dynamiclist', {
          params: {
            page: this.page
          }
        }).then(res => {
          if (res.status = 200) {
            var data = res.data.dynamiclist;
            this.dynamicList = data;
            this.total = res.data.dynamiccount;
          }
        })
      },

      // 获取新闻列表
      getNewsList() {
        // this.$axios.get('http://www.csaln.cn/api/newslist', {
        //   params: {
        //     page: this.page
        //   }
        // }).then(res => {
        //   if (res.status = 200) {
        //     var data = res.data.newslist;
        //     //  for (var i in data) {
        //     //      var oldTime = new Date(data[i].time);
        //     //     var y=oldTime.getFullYear(),m=oldTime.getMonth()+1,d=oldTime.getDate();
        //     //      data[i].time=y+'-'+m+'-'+d;
        //     //  }
        //     this.newslist = data;
        //     this.total = res.data.newscount;
        //   }
        // });
      },
      //分页,当页码改变时重新发起请求
      handleCurrentChange(val) {
        this.page = val;
        this.getNewsList();
      },
    },

  }
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .news-main {
    /* width: 1200px; */
    position: relative;
    width: 100%;
    margin: 40px auto;
    padding: 40px 40px;
    /* background-color: rgba(255, 255, 255, 0.85) */

    background: hsla(0, 0%, 100%, .4);
    /* border: 0.1vw solid rgb(60, 74, 93, .2); */
    /* border-radius: 0.9375rem; */
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .1);
  }

  /* .el-pagination {
    margin-top: 40px;
  } */

  .listArea {
    position: relative;
    width: 100%;
  }

  .list {
    margin-bottom: 20px;
    border-bottom: 2px solid rgba(51, 63, 80, 0.3);
  }

  .list>li {
    padding: 10px 40px;
    list-style: none;
  }

  .list>.title>a {
    font-size: 18px;
    font-weight: bold;
    color: #333F50;
  }

  .list>.title>a:hover {
    text-decoration: underline;
  }

  /* .list>.title>a:visited{
    color: rgb(124, 138, 158);
  } */

  .list>.intr,
  .list>.author {
    color: #857878;
  }

  .author>.publishing {
    margin-right: 40px;
  }

  .pubtime {
    display: inline-block;
  }

  .publishing {
    display: inline-block;
  }

  @media screen and (max-width:500px) {
    .list>li {
      padding: 10px 10px;
      list-style: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/DynamicList.vue